<template>
  <section>
    <div :class="$style['section-name']">
      {{ locales('settings_global_columns_title') }}
    </div>
    <div :class="$style['custom-field-list']">
      <custom-field-row
        v-for="column in customFieldsColumns"
        :key="column.id"
        :field-column="column"
        :field-value="customFieldsValues[column.id]"
        :disabled="isCustomFieldsDisabled"
        :task-data="taskData"
        @change="$emit('change', $event)"
      />
    </div>
  </section>
</template>

<script>
import CustomFieldRow from './includes/CustomFieldRow.vue';

export default {
  name: 'TaskSettingsCustomFields',
  components: { CustomFieldRow },
  inject: ['isFieldDisabled'],
  props: {
    taskData: {
      type: Object,
      default: null,
    },
    customFieldsColumns: {
      type: Array,
      default: () => [],
    },
    customFieldsValues: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      locales: __,
    };
  },
  computed: {
    isCustomFieldsDisabled() {
      return this.isFieldDisabled('custom_fields');
    },
  },
};
</script>

<style module lang="less">

.section-name {
  font-family: Lato-Bold, sans-serif;
  font-size: 14px;
  line-height: 24px;
  color: #191919;
  margin-bottom: 16px;
}

.custom-field-list {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

</style>
